import React from "react";
import Modal from "react-modal";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import { IAdquirinte } from "..";
import { useAdquirinte } from "../../../../Storage/Adquirente";

// Estilizando o botão Excluir com a cor vermelha
const RedButton = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.error.main,
  color: theme.palette.getContrastText(theme.palette.error.main),
  "&:hover": {
    backgroundColor: theme.palette.error.dark,
  },
}));

const customStyles = {
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0.5)",
  },
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    backgroundColor: "white", // Cor de fundo do modal
    minWidth: "40%",
    maxWidth: "80%",
    borderRadius: "0.25rem",
    padding: "2rem", // Adicionando um pouco de padding
  },
};

interface Props {
  open: boolean;
  onClose: () => void;
  adquirente: IAdquirinte;
}
export const ExcluirModal = ({ open, onClose, adquirente }: Props) => {
  const { excluir } = useAdquirinte();

  return (
    <Modal isOpen={open} onRequestClose={onClose} style={customStyles}>
      <div>
        <h2>Confirmação de Exclusão</h2>
        <p>Deseja realmente excluir {adquirente.NOME}?</p>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginTop: "1rem",
          }}
        >
          <Button
            onClick={onClose}
            variant="contained"
            color="primary"
            style={{ marginRight: "1rem" }}
          >
            Cancelar
          </Button>
          <RedButton
            onClick={() => {
              excluir(Number(adquirente.ID));
              onClose();
            }}
            variant="contained"
          >
            Excluir
          </RedButton>
        </div>
      </div>
    </Modal>
  );
};
